import { render, staticRenderFns } from "./CreateNewAccount.vue?vue&type=template&id=d8a478f8&scoped=true&lang=pug"
import script from "./CreateNewAccount.vue?vue&type=script&lang=js"
export * from "./CreateNewAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateNewAccount.vue?vue&type=style&index=0&id=d8a478f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a478f8",
  null
  
)

export default component.exports